import { render, staticRenderFns } from "./limit_time_discount_edit.vue?vue&type=template&id=23a663f2&scoped=true"
import script from "./limit_time_discount_edit.vue?vue&type=script&lang=js"
export * from "./limit_time_discount_edit.vue?vue&type=script&lang=js"
import style0 from "./limit_time_discount_edit.vue?vue&type=style&index=0&id=23a663f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a663f2",
  null
  
)

export default component.exports